module.exports = __webpack_public_path__ + "img/dentalfit_16_a.b699f729.jpg";